import { render, staticRenderFns } from "./Subscriber.vue?vue&type=template&id=2c3a7bc3&scoped=true"
import script from "./Subscriber.vue?vue&type=script&lang=js"
export * from "./Subscriber.vue?vue&type=script&lang=js"
import style0 from "./Subscriber.vue?vue&type=style&index=0&id=2c3a7bc3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a7bc3",
  null
  
)

export default component.exports